<template>
  <div id="community-card">
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="55%"></b-skeleton>
        <b-skeleton width="70%"></b-skeleton>
      </template>

      <Card>
        <div class="d-flex align-items-center justify-content-between mb-5">
          <h3 class="text-dark font-size-secondary">PlusClouds Blog</h3>

          <a
            :href="blogUrl"
            target="_blank"
            class="btn btn-primary btn-sm rounded-sm"
          >
            {{ $t('dashboard.goToBlog') }}
          </a>
        </div>

        <div
          class="d-flex mb-7"
          v-for="item in items.slice(0, 5)"
          :key="item.id"
        >
          <div>
            <a :href="`${blogUrl}/${item.slug}`" target="_blank">
              <img
                :src="`${item.header_image}`"
                class="community-image"
                :alt="item.title"
                v-if="item.header_image && item.header_image.startsWith('http')"
              />

              <img
                :src="`https://static.plusclouds.com/${item.header_image}`"
                class="community-image"
                :alt="item.title"
                v-else-if="
                  item.header_image && !item.header_image.startsWith('http')
                "
              />
              <img
                src="https://static.plusclouds.com/static/images/components/blog/blog-thumbnail-small.svg"
                class="community-image"
                :alt="item.title"
                v-else
              />
            </a>
          </div>
          <!--begin::Text-->
          <div class="flex-grow-1">
            <div class="d-flex">
              <div class="mb-2">
                <a
                  :href="`${blogUrl}/${item.slug}`"
                  target="_blank"
                  class="text-dark fw-bolder text-hover-primary fs-6 mb-2"
                  v-html="item.title"
                ></a>
                <br />
                <small class="text-muted fw-bold font-size-small">
                  {{
                    $customFunctions.setMomentWithFormat(
                      item.created_at,
                      'DD.MM.yyyy HH:mm'
                    )
                  }}</small
                >
              </div>
              <!-- <div class="ml-auto">
                <a :href="`${blogUrl}/${item.slug}`"
                   target="_blank"
                   class="btn btn-secondary btn-sm rounded-sm">
                  {{$t('dashboard.readTheArticle')}}
                </a>
              </div> -->
            </div>
            <span
              class="text-muted d-block fw-bold"
              v-html="$customFunctions.splitHtml(item.body, 200)"
            ></span>
          </div>
          <!--end::Text-->
        </div>
      </Card>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'

export default {
  name: 'Dashboard.Community',
  data() {
    return {
      loading: true,
      items: [],
    }
  },
  created() {
    this.getItems()
  },
  computed: {
    blogUrl() {
      return process.env.VUE_APP_BLOG_URL && process.env.VUE_APP_BLOG_URL != ''
        ? process.env.VUE_APP_BLOG_URL
        : ''
    },
  },
  methods: {
    getItems() {
      ApiService.get(
        `discussion/threads?threadType=blogpost&domainId=${process.env.VUE_APP_DOMAIN_ID}`
      )
        .then((res) => {
          this.items = res.data.data
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#community-card {
  .community-image {
    width: 200px;
    box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
    margin-right: 20px;
  }
}
</style>
